import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { HeaderTabs } from '../../../components/NavBar/HeaderTabs';
import { tabs } from '../../../components/NavBar/navigationStructure';
import { Header, HeaderProps } from '../../../ui/header/Header';
import { ExtensionsBreadcrumbs } from './ExtensionsBreadcrumbs';

type ExtensionsPageKeys =
  | 'rossumStore'
  | 'externalStore'
  | 'myExtensions'
  | 'logs';

type ExtensionsHeaderProps = {
  value: ExtensionsPageKeys;
} & Pick<HeaderProps, 'scrollableDivRef' | 'title' | 'buttons'>;

export const ExtensionsHeader = ({
  value,
  ...params
}: ExtensionsHeaderProps) => {
  const intl = useIntl();
  const history = useHistory();

  const onBackButtonClicked = useCallback(() => {
    if (history.length > 1) {
      return history.goBack();
    }

    return history.push('/documents');
  }, [history]);

  return (
    <Header
      {...params}
      description={null}
      onBackButtonClicked={onBackButtonClicked}
      breadcrumbs={
        <ExtensionsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: `components.appBar.menu.extensions.${value}`,
              }),
            },
          ]}
        />
      }
      tabs={
        <HeaderTabs
          dataCy="extensions-tabs"
          menuItems={tabs.find(tab => tab.name === 'extensions')?.menu ?? []}
          value={value}
        />
      }
    />
  );
};
